import { render, staticRenderFns } from "./InvoiceView.vue?vue&type=template&id=8c8388ea&"
import script from "./InvoiceView.vue?vue&type=script&lang=ts&"
export * from "./InvoiceView.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceView.vue?vue&type=style&index=0&id=8c8388ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports